import React from "react";
import { FlatButton, Checkbox } from "material-ui";

import BaseOverlay from "./base.jsx";
import CurrencyField from "../currency-field.jsx";
import WorkingIndicator from "../working-indicator.jsx";
import { formatPrice } from "../../../util";
import { Table, Tr, Td, Sort } from "reactable";

import UserStore from "../../../stores/UserStore";
import OrderUtil from "../../../utils/OrderUtil";

const styles = {
  note: {
    marginTop: "1em",
    fontSize: "0.8em"
  }
};

class RefundOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      amount: null,
      options: null,
      refunds: {}
    };

    this.refund = this.refund.bind(this);
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);

    // if options was provided
    if (!this.props.options && this.props.order && this.props.order.in_ledger) {
      OrderUtil.generateRefundOptions(
        UserStore.getState().apiKey,
        this.props.order.id
      )
        .then(res => {
          this.setState({ options: res.options });
        })
        .catch(e => {
          window.alert(`Failed to generate refund options: ${e.message}`);
        });
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      amount: props.order && props.order.purchase_price,
      options: props.options
    });
  }

  refund() {
    this.props.onRefund(
      (this.props.order && this.props.order.in_ledger) || this.props.options
        ? { refunds: this.state.refunds }
        : this.state.amount
    );
  }

  render() {
    let { onRequestClose, order, options } = this.props;

    const ledgerMode = (order && order.in_ledger) || (!order && !!options);

    return (
      <BaseOverlay
        onRequestClose={onRequestClose}
        useMuiDefaultStyle={true}
        actions={[
          <FlatButton label="Cancel" onTouchTap={onRequestClose} />,
          <FlatButton
            primary={true}
            label={`Refund${
              ledgerMode
                ? ` ${formatPrice(
                    Object.values(this.state.refunds).reduce(
                      (t, r) => t + r.amount,
                      0
                    ),
                    { currency: order && order.currency }
                  )}`
                : ""
            }`}
            onTouchTap={this.refund}
          />
        ]}
      >
        {this.props.refundErrorMessage ? (
          <div
            style={{ color: "red", marginBottom: "1em", fontWeight: "bold" }}
          >
            Failed to refund: {this.props.refundErrorMessage}
          </div>
        ) : null}

        <div>
          {order ? (
            <div>
              Refund up to <strong>{formatPrice(order.purchase_price)}</strong>.
            </div>
          ) : null}
          Refunds are irreversible. A confirmation email will be sent to the
          customer.
        </div>

        {ledgerMode ? (
          <div style={{ marginTop: "1em" }}>
            <div style={{ marginBottom: "1em" }}>
              Check the box in the lefthand column next to each item you would
              like to refund. Specify partial refunds and choose whether or not
              to delete the associated item using the righthand column. When
              you're ready to perform the refund, click "Refund" in the lower
              righthand corner.
            </div>

            {this.state.options ? (
              <Table
                className={"bordered striped responsive-table"}
                columns={[
                  {
                    label: (
                      <Checkbox
                        iconStyle={{ fill: "#fff" }}
                        checked={this.state.options.every(
                          o =>
                            this.state.refunds[o.refund_key] &&
                            this.state.refunds[o.refund_key].amount ===
                              o.refundable_amount
                        )}
                        onCheck={(e, v) =>
                          this.setState({
                            refunds: this.state.options.reduce((d, o) => {
                              d[o.refund_key] = {
                                amount: v ? o.refundable_amount : 0,
                                delete: v && !o.item_deleted ? true : false
                              };
                              return d;
                            }, {})
                          })
                        }
                      />
                    ),
                    key: "select"
                  },
                  "Item",
                  "Refundable",
                  "Refund"
                ]}
                data={this.state.options.map(o => {
                  const refund = this.state.refunds[o.refund_key] || {
                    amount: 0,
                    delete: false
                  };

                  return {
                    select: (
                      <span>
                        <Checkbox
                          checked={refund.amount > 0}
                          disabled={o.refundable_amount === 0}
                          onCheck={(e, v) =>
                            this.setState({
                              refunds: {
                                ...this.state.refunds,
                                [o.refund_key]: {
                                  ...refund,
                                  amount: v ? o.refundable_amount : 0,
                                  delete: !!v && !o.item_deleted
                                }
                              }
                            })
                          }
                        />
                      </span>
                    ),
                    Item: `${o.class}: ${[
                      o.category && o.category.ref_label,
                      o.subcategory && o.subcategory.ref_label,
                      o.variant && o.variant.ref_label,
                      o.item && o.item.ref_label
                    ]
                      .filter(x => !!x)
                      .join(" - ")} (${formatPrice(o.amount, {
                      currency: o.currency
                    })})`,
                    Refundable: formatPrice(o.refundable_amount, {
                      currency: o.currency
                    }),
                    Refund: (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CurrencyField
                          placeholder="$0.00"
                          style={{
                            width: 80,
                            minWidth: 80,
                            marginRight: "1em"
                          }}
                          value={refund.amount}
                          onChange={e =>
                            this.setState({
                              refunds: {
                                ...this.state.refunds,
                                [o.refund_key]: {
                                  ...refund,
                                  amount: e.target.value
                                }
                              }
                            })
                          }
                        />
                        {
                          o.class === "GIFT_CARD" ? null : (
                            o.item_deleted ? (
                              <span
                                style={{
                                  fontSize: "0.8em",
                                  color: "rgba(0,0,0,0.7)",
                                  fontStyle: "italic",
                                  lineHeight: "1.1em"
                                }}
                              >
                                {o.class === "TAX"
                                  ? "Not deletable"
                                  : "Already deleted"}
                              </span>
                            ) : (
                              <Checkbox
                                label="Delete"
                                style={{ display: "inline-block" }}
                                checked={refund.delete}
                                labelStyle={{
                                  fontSize: "0.8em",
                                  color: "rgba(0,0,0,0.7)",
                                  marginLeft: -10
                                }}
                                onCheck={(e, v) =>
                                  this.setState({
                                    refunds: {
                                      ...this.state.refunds,
                                      [o.refund_key]: {
                                        ...refund,
                                        delete: v
                                      }
                                    }
                                  })
                                }
                              />
                            )
                          )
                        }
                      </div>
                    )
                  };
                })}
              />
            ) : (
              <WorkingIndicator centered />
            )}
          </div>
        ) : (
          <div>
            <CurrencyField
              floatingLabelText="Refund amount"
              floatingLabelFixed={true}
              value={this.state.amount}
              onChange={e => this.setState({ amount: e.target.value })}
            />
            <div style={styles.note}>
              Note: <strong>Refunds DO NOT delete purchased items.</strong>{" "}
              After issuing a refund, you must delete items using "Delete" links
              in the table on the order page.
            </div>
          </div>
        )}
      </BaseOverlay>
    );
  }
}

export default RefundOverlay;



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/refund.jsx